import { gatewayService } from "@/_services/gateway.service";

/**
 * Retrieves exposure options for commodities
 */

export function getExpoOptionsDataCommodities(_this) {
  gatewayService.commodities
    .exposureOption({ format: "json" })
    .then(data => {
      _this.expoOptionsCommodities = data;
      let txt = "One of the following: ";
      _this.expoOptionsCommodities.forEach((d, i) =>
        i < _this.expoOptionsCommodities.length - 1
          ? (txt += d.name + ", ")
          : (txt += d.name + ".")
      );
      var index = _this.headersComExpo1
        .map(function(d) {
          return d.text;
        })
        .indexOf("Exposure Type");
      if (index > -1) {
        _this.headersComExpo1[index].explain = txt;
      } else {
        console.log("Could not load expoOptions to headersComExpo1");
      }
    })
    .catch(function(error) {
      console.log(error);
    });
}
